module.exports = __webpack_public_path__ + "img/88551d56866e66b28332dc7f2bcb97c3.a95d3aed.jpg";